var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.3 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5,.cls-7,.cls-9{fill:none;}.cls-2{fill:#f8ab5d;}.cls-3{fill:#ffe779;}.cls-4{clip-path:url(#clip-path);}.cls-5{stroke:#f8ab5d;}.cls-5,.cls-7,.cls-9{stroke-linecap:round;stroke-linejoin:round;stroke-width:2.6px;}.cls-6{fill:#22272e;}.cls-7{stroke:#6dafa7;}.cls-8{fill:#6dafa7;}.cls-9{stroke:#22272e;}.cls-10{fill:#63737a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.05,382.12l-129.13-7.94a16,16,0,0,1-14.86-18.9l49.2-275.71a21.59,21.59,0,0,1,19-17.6L289,49.42a16.16,16.16,0,0,1,17.46,18.76l-49,296.05A21.39,21.39,0,0,1,235.05,382.12Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.12,383,113,375.05a16,16,0,0,1-14.86-18.9l49.2-275.71a21.59,21.59,0,0,1,19-17.6l129.7-12.55A16.15,16.15,0,0,1,313.53,69l-49,296A21.27,21.27,0,0,1,242.12,383Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.05,382.12l-129.13-7.94a16,16,0,0,1-14.86-18.9l49.2-275.71a21.59,21.59,0,0,1,19-17.6L289,49.42a16.16,16.16,0,0,1,17.46,18.76l-49,296.05A21.39,21.39,0,0,1,235.05,382.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.18,226.3l-198.81,3.46a8.21,8.21,0,0,1-8.22-9.66l14.57-83a10.59,10.59,0,0,1,9.52-8.66l196.21-13.13a10.44,10.44,0,0,1,11,12.12L375,217.64A9.73,9.73,0,0,1,365.18,226.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.25,360l-198.81-8.65a8.35,8.35,0,0,1-7.79-9.67l15-85a10.5,10.5,0,0,1,10.24-8.65l196.5-1.59a10.49,10.49,0,0,1,10.39,12.12l-14.72,92.77A10.47,10.47,0,0,1,343.25,360Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 137.23,
    y1: 96.17,
    x2: 304.01,
    y2: 82.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.06,76.11l-14.28,1.3c-1.3.15-2-.86-1.88-2.31h0a3.39,3.39,0,0,1,2.74-2.74l14.29-1.3c1.3-.14,2.16.87,1.87,2.31h0A3.54,3.54,0,0,1,222.06,76.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.58,75.25h0c-1.3.14-2.16-.87-1.87-2.31h0a3.37,3.37,0,0,1,2.74-2.74h0c1.3-.15,2.16.86,1.87,2.31h0A3.06,3.06,0,0,1,231.58,75.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M392.3,85.06l-55,4.18a2.92,2.92,0,0,1-3.18-3.46l5.48-33.33a4.44,4.44,0,0,1,4-3.75l54.39-5.77a3.55,3.55,0,0,1,3.9,4l-5.34,34.34A5.08,5.08,0,0,1,392.3,85.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M341.09,49.57,365,65a3.9,3.9,0,0,0,4.32,0l31.17-21.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.3,147.38l-45.16,2.46-6.64,4.32A2.07,2.07,0,0,1,89.33,152l7.07-39.24a7,7,0,0,1,6.35-5.77l47-3.61a4.69,4.69,0,0,1,5.05,5.48l-6.06,34.34A4.88,4.88,0,0,1,144.3,147.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 105.2,
    y1: 118.53,
    x2: 143.29,
    y2: 115.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 103.47,
    y1: 128.19,
    x2: 141.56,
    y2: 125.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 101.74,
    y1: 137.72,
    x2: 121.65,
    y2: 136.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.5,217.5,155.7,221a8.22,8.22,0,0,1-8.23-9.66l14.57-83a10.59,10.59,0,0,1,9.53-8.66l196.21-13.13a10.44,10.44,0,0,1,11,12.12l-14.43,90.17A9.83,9.83,0,0,1,354.5,217.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.2,154.74c-1,5.92-6.2,11-11.54,11.25s-8.8-4.32-7.79-10.24,6.2-11,11.54-11.25S208.21,148.83,207.2,154.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.45,192.69l-23.66.72a5.06,5.06,0,0,1-5.19-5.92l.43-2.6c1.87-10.67,11.11-19.76,20.77-20h0c9.67-.43,16.16,8.08,14.29,18.9l-.58,3.75A6.47,6.47,0,0,1,203.45,192.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M333.15,155.75l-94.21,4.33a3,3,0,0,1-3.17-3.61l1-6.35a4.74,4.74,0,0,1,4.33-3.89l94.35-4.91a3,3,0,0,1,3.17,3.61l-1.15,6.93A4.48,4.48,0,0,1,333.15,155.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "237.93 177.1 239.37 181.58 243.85 182.3 239.95 186.19 239.66 191.24 235.91 189.22 231.29 191.53 232.74 186.48 230.14 182.88 234.9 181.72 237.93 177.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "259.57 176.38 261.16 180.85 265.63 181.58 261.74 185.47 261.59 190.52 257.55 188.5 252.94 190.81 254.38 185.76 251.78 182.01 256.54 181 259.57 176.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "281.79 175.52 283.38 179.99 287.99 180.85 283.95 184.75 283.81 189.94 279.77 187.78 275.01 190.23 276.45 185.04 273.71 181.29 278.76 180.13 281.79 175.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "304.44 174.65 306.03 179.27 310.79 179.99 306.75 184.03 306.61 189.22 302.42 187.06 297.52 189.51 299.1 184.17 296.22 180.57 301.27 179.41 304.44 174.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "327.67 173.78 329.26 178.4 334.16 179.27 329.98 183.16 329.83 188.5 325.5 186.34 320.6 188.79 322.19 183.45 319.3 179.7 324.35 178.55 327.67 173.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.43,351.24l-198.66-8.8a8.33,8.33,0,0,1-7.79-9.67l15-85a10.51,10.51,0,0,1,10.24-8.66l196.5-1.59a10.48,10.48,0,0,1,10.39,12.12L343.4,342.44A10.62,10.62,0,0,1,332.43,351.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M186,277.52c-1,6.06-6.2,11-11.68,10.82s-8.8-5-7.79-11.11,6.2-10.82,11.54-10.82S187.15,271.46,186,277.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.81,316.47l-23.66-.72a5.22,5.22,0,0,1-4.91-5.92l.58-3c1.88-11,11.11-19.63,20.78-19.48h0c9.66.14,16.15,9.23,14.13,20.34l-.57,3.61A6.27,6.27,0,0,1,181.81,316.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311.66,286.46l-94.22-1.3a3.11,3.11,0,0,1-3-3.6l1.15-6.64a4.64,4.64,0,0,1,4.62-3.89l94.35.72a3.11,3.11,0,0,1,3,3.6l-1.15,7.22A5,5,0,0,1,311.66,286.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.58 302.62 218.02 307.24 222.49 308.25 218.6 312 218.46 317.19 214.56 314.74 209.94 316.9 211.38 311.71 208.93 307.96 213.55 307.09 216.58 302.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "238.36 303.05 239.81 307.67 244.42 308.82 240.38 312.58 240.24 317.77 236.2 315.46 231.58 317.63 233.03 312.43 230.43 308.39 235.34 307.67 238.36 303.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "260.58 303.63 262.02 308.25 266.79 309.4 262.75 313.15 262.46 318.49 258.42 316.04 253.66 318.2 255.24 313.01 252.5 308.97 257.41 308.25 260.58 303.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "283.23 304.06 284.82 308.82 289.58 309.98 285.4 313.88 285.25 319.21 281.07 316.76 276.16 318.92 277.75 313.59 275.01 309.55 280.06 308.68 283.23 304.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "306.32 304.64 308.05 309.4 312.81 310.56 308.63 314.45 308.48 319.93 304.3 317.34 299.25 319.65 300.83 314.16 297.95 310.27 303.14 309.4 306.32 304.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329,18.69a5.82,5.82,0,1,0-.43,8.23A5.77,5.77,0,0,0,329,18.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321.18,5.13l-1-1.15a9.15,9.15,0,0,0-13-.58h0a9.14,9.14,0,0,0-.57,13l1,1.16a11,11,0,0,1,2.45,4.61c.29,1.3.72,2.89,1.15,4.33a4.32,4.32,0,0,0,7.07,2.17l6.49-5.92,6.5-5.91a4.28,4.28,0,0,0-1.45-7.22c-1.44-.57-2.88-1-4.18-1.44A16.38,16.38,0,0,1,321.18,5.13Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.ff1b02f241a06dd48baed6e94af0bfb7.svg";
export { ForwardRef as ReactComponent };